module.exports = __webpack_public_path__ + "static/media/refer-bg.56213d8e.png";